<template>
  <div>
      <div class="" style="margin-bottom: 83px;">
            <div class="TSDN-title">关于Amazon SEND（亚马逊跨境承运伙伴方案）</div>
            <div class="TSDN-content">
              Amazon SEND（亚马逊跨境承运伙伴方案），指由亚马逊筛选的物流合作承运人将卖家货件从中国发往目的国的亚马逊运营中心，为卖家提供了从上门取货到完成送仓一站式集成服务，全程可以在卖家平台完成并追踪，减少运营成本的同时也让卖家更安心。
            </div>
        </div>

  </div>
</template>
<script>


/**
* Index-1 component
*/
export default {
components: {

},
data(){
  return {
      
  }
},
methods: {
 
}
};
</script>
<style src="./componentsIndex.css" scoped>

</style>